import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { ResourcesEndpointEnum } from 'src/app/core/enums/resources-endpoint.enum';
import { ReportConfig } from 'src/app/core/interfaces/report-config';
import { ResourceService } from 'src/app/core/services/resource.service';
import { NgIf } from '@angular/common';
import { IonicModule, PopoverController } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { ConfigurationPopoverComponent } from '../popovers/configuration-popover/configuration-popover.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RequiredRolesDirective, DirectiveCondition, DirectiveRole } from 'src/app/core/directives/required-roles.directive';
import { ReportsStore } from 'src/app/core/stores/reports.store';

@Component({
  selector: 'app-report-card',
  templateUrl: './report-card.component.html',
  styleUrls: ['./report-card.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    IonicModule,
    RouterLink,
    TranslateModule,
    RequiredRolesDirective
  ],
})

export class ReportCardComponent implements OnInit {
  @Input()
  report!: ReportConfig;
  @Input()
  groupId!: number;
  @Input()
  onMobileView: boolean | undefined;
  @Input()
  groupName?: string;
  @Input()
  collapsableTitle?: string;
  isPremium = false;
  descriptionPopoverOpen = false;
  DirectiveRole = DirectiveRole;
  DirectiveCondition = DirectiveCondition;

  @ViewChild('descriptionPopover') descriptionPopover!: HTMLIonPopoverElement;

  constructor(private resourceService: ResourceService,
    private toastrService: ToastrService,
    private popoverController: PopoverController,
    private translateService: TranslateService,
    private reportsStore: ReportsStore,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void { }

  setAsFavorite(event: any, report: ReportConfig) {
    event.stopPropagation();
    event.preventDefault();

    this.resourceService.put<any>(ResourcesEndpointEnum.PUT_REPORT_FAVORITE, {}, { reportID: report.ReportID })
      .subscribe({
        next: () => {
          report.UsersFavorite = !report.UsersFavorite;
          this.reportsStore.pinnedFavorites = null;
          const key = report.UsersFavorite ? 'Added to favorites' : 'Removed from favorites';
          this.translateService.get(key).subscribe(t => this.toastrService.success(t));
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.translateService.get('Error when toggling favorite report').subscribe(t => {
            this.toastrService.error(t);
          })
          throwError(() => err);
        },
        complete: () => { }
      });
  }

  openDescriptionPopover(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.descriptionPopover.event = event;
    this.descriptionPopoverOpen = true;
  }
}
